import { CustomCellDate, CrudLink } from "@/shared/components";
import type { DataListViewColumns } from "@/shared/components/DataListView";
import { Stack, Typography } from "@mui/material";
import type { ConfigRow } from "./types";
import type { ColumnDefinition } from "@/shared/components/CRUD/types";

export const getColumnsConfig = (): ColumnDefinition<ConfigRow>[] => [
  { name: "id", label: "ID", options: { display: false, filter: false } },
  {
    name: "key",
    label: "Ключ",
    options: {
      setCellHeaderProps: () => ({ style: { minWidth: 200 } }),
      customBodyRender: (data: unknown) => {
        const row = data as ConfigRow;
        return (
          <CrudLink id={row.id} tab="details">
            {row.key}
          </CrudLink>
        );
      },
    },
  },
  {
    name: "value",
    label: "Значение",
    options: {
      setCellHeaderProps: () => ({ style: { minWidth: 160 } }),
    },
  },
  {
    name: "createdAt",
    label: "Создан",
    options: {
      setCellHeaderProps: () => ({ style: { width: 150 } }),
      customBodyRender: (value: unknown) => (
        <CustomCellDate date={value as string} />
      ),
    },
  },
];

export const getTextsConfig = () => ({
  filterTitle: "Фильтры",
  listTitle: "Конфиги",
  itemCreated: "Запись создана",
  itemUpdated: "Запись обновлена",
  createItem: "Создать запись",
  refetchList: "Обновить список",
  deleteItems: "Удалить",
  itemsDeleted: "Удалено",
  restoreItems: "Восстановить",
  itemsRestored: "Восстановлено",
  cancel: "Отмена",
  editItem: "Конфиг",
  showTitle: "Детали",
});

// Колонки для мобильного представления: ключ с значением и дата
export const getMobileColumnsConfig = (): DataListViewColumns<ConfigRow> => ({
  main: {
    title: "Ключ",
    sx: { flex: 1, minWidth: 0 },
    renderCell: (row) => (
      <Stack sx={{ minWidth: 0 }}>
        <CrudLink id={row.id} tab="details" noWrap>
          {row.key}
        </CrudLink>
        <Typography variant="body2" color="textSecondary" noWrap>
          {row.value ?? "—"}
        </Typography>
      </Stack>
    ),
  },
  createdAt: {
    title: "Создан",
    sx: { width: 96, flexShrink: 0 },
    renderCell: (row) => <CustomCellDate date={row.createdAt as string} />,
  },
});
